import { Scatter } from "react-chartjs-2";
import { ChartOptions } from "chart.js";
import { humanReadableMetric, AXIS_LIMITS, getMetricValue, getLinePointsForInnings, InsightsPageMetric } from "./insights-page-utils";
import { BirdBowlData } from "../../types/bird/bird-bowl-data";

interface BallByBallChartProps {
  readonly updates: ReadonlyArray<BirdBowlData & { processedSequence: number }>;
  readonly selectedMetric: InsightsPageMetric;
}

export default function BallByBallChart({
  updates,
  selectedMetric,
}: BallByBallChartProps) {

  const firstInningsLinePoints: { x: number; y: number }[] = getLinePointsForInnings(updates, 1, selectedMetric);
  const secondInningsLinePoints: { x: number; y: number }[] = getLinePointsForInnings(updates, 2, selectedMetric);

  // Ball-by-ball scatter plot, showing the selected metric progression over time within this game
  const data = {
    datasets: [
      {
        label: `${
          selectedMetric.charAt(0).toUpperCase() + selectedMetric.slice(1)
        }`,
        data: updates.map((update) => ({
          x: update.processedSequence,
          y: getMetricValue(update, selectedMetric),
        })),
        backgroundColor: "rgba(75, 192, 192, 1)",
      },
      {
        label: "First Innings Trend",
        data: firstInningsLinePoints,
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 2,
        fill: false,
        pointRadius: 0,
        showLine: true,
        type: "line",
      } as any,
      {
        label: "Second Innings Trend",
        data: secondInningsLinePoints,
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 2,
        fill: false,
        pointRadius: 0,
        showLine: true,
        type: "line",
      } as any,
    ],
  };

  const options: ChartOptions<"scatter"> = {
    scales: {
      x: {
        title: { display: true, text: "Sequence" },
      },
      y: {
        title: { display: true, text: humanReadableMetric[selectedMetric] },
        min: AXIS_LIMITS[selectedMetric]?.min,
        max: AXIS_LIMITS[selectedMetric]?.max,
      },
    },
    plugins: {
      legend: {
        display: true,
      },
    },
  };

  return <Scatter data={data} options={options} />;
}
